import React from "react"
import { Grid, Link, Typography } from "@material-ui/core"
import { DeleteOutlined as DeleteIcon, ErrorOutline as ErrorOutlineIcon, LocalOffer as TagIcon, OpenInNew as OpenInNewIcon } from "@material-ui/icons"

import { TagOption } from "@/protocols/chatBotConstructor"
import { colors } from "@/styles/colors"
import { convertRGBAObjectToString } from "@/utils/color"

import useStyles from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/resources/Blocks/AIManageClientTagsBlock/TagDescriptionEditor/styles"

type TagDescriptionEditorProps = {
	tags: TagOption[]
	onTagRemove: (tagId: number) => void
}

const MISSING_DESCRIPTION_WARNING = "Esta tag não tem descrição. Sem ela, a IA não consegue identificar quando aplicar."
const EDIT_DESCRIPTION_LINK_LABEL = "Editar descrição"
const ADD_DESCRIPTION_LINK_LABEL = "Adicionar descrição"

const buildTagEditUrl = (tagId: number): string => {
	return `${window.location.origin}/admin/contacts/tags?tagId=${tagId}`
}

const TagDescriptionEditor: React.FC<TagDescriptionEditorProps> = (props) => {
	const {
		tags,
		onTagRemove
	} = props

	const classes = useStyles()

	if (tags.length === 0) {
		return null
	}

	return (
		<Grid
			container
			direction="column"
			spacing={1}
		>
			{tags.map(tag => {
				const hasDescription = Boolean(tag.description?.trim())

				return (
					<Grid
						item
						key={tag.id}
					>
						<Grid className={classes.tagCard}>
							<Grid
								container
								alignItems="center"
								spacing={1}
								className={classes.tagCardHeader}
							>
								<Grid
									item
									className={classes.tagIconBox}
								>
									<TagIcon
										style={{
											color: convertRGBAObjectToString(tag.color),
											fontSize: 22
										}}
									/>
								</Grid>

								<Grid
									item
									xs
								>
									<Typography className={classes.tagEyebrow}>
										Tag
									</Typography>
									<Typography className={classes.tagName}>
										{tag.name}
									</Typography>
								</Grid>

								<Grid
									item
									className={classes.deleteButton}
									onClick={() => onTagRemove(tag.id)}
								>
									<DeleteIcon
										style={{
											color: colors.red[600],
											fontSize: 16
										}}
									/>
								</Grid>
							</Grid>

							<Grid className={classes.tagContentColumn}>
								{hasDescription ? (
									<Typography className={classes.descriptionText}>
										{tag.description}
									</Typography>
								) : (
									<Grid
										container
										alignItems="center"
										spacing={1}
										className={classes.warningRow}
									>
										<Grid
											item
											className={classes.warningIconBox}
										>
											<ErrorOutlineIcon className={classes.warningIcon} />
										</Grid>

										<Grid
											item
											xs
										>
											<Typography className={classes.warningText}>
												{MISSING_DESCRIPTION_WARNING}
											</Typography>
										</Grid>
									</Grid>
								)}

								<Link
									href={buildTagEditUrl(tag.id)}
									target="_blank"
									rel="noopener noreferrer"
									className={classes.editLink}
								>
									{hasDescription ? EDIT_DESCRIPTION_LINK_LABEL : ADD_DESCRIPTION_LINK_LABEL}
									<OpenInNewIcon className={classes.editLinkIcon} />
								</Link>
							</Grid>
						</Grid>
					</Grid>
				)
			})}
		</Grid>
	)
}

export default TagDescriptionEditor
